module.exports = __webpack_public_path__ + "img/99d0.36723218.png";